import React, { useContext, useEffect, useState } from "react"
import styled from "@emotion/styled"
import { Box, Flex } from "@rebass/grid/emotion"

import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

import CheckedIcon from "../../../../../assets/icons/wild/checkmark-icon-white-square.svg"

import Image from "../../../../image"
import MenSingleOption from "./mensingleoption"
import MenSingleOptionPromo2in1 from "./mensingleoption-promo-2in1"
import FaqArea from "./faq"
import ImageArea from "./imagearea"
import HairSerumCoreUpsell from "../../activecleanse/cleanse-duo-upsell"

import ModalWildImage from "../../../master/modalwildimage"
import UserContext from "../../../../../context/UserContext"

const ATCFullWrap = styled.div`
  .supplinkwrap {
    #Modal {
      margin: 0 auto;
      max-height: 100%;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 515px;

      > div {
        padding: 12px 12px;
        background: #fff;
        border-radius: 16px;
      }
    }
  }

  .imageareawrap {
    padding-top: 40px !important;
    @media (min-width: 768px) {
      padding-top: 8px !important;
    }
  }

  .supplinkmob {
    text-align: center;
    margin-top: 16px;
  }

  .left {
    text-align: left;
    padding: 0 5%;
  }
`
const ATCWrap = styled(Flex)`
  flex-direction: row;
  width: 100%;
  max-width: 1488px;

  padding: 40px 0 0 0;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 768px) {
    padding: 40px 32px;
  }
  @media (min-width: 1280px) {
    padding: 80px 0 80px 32px;
  }
  @media (min-width: 1800px) {
    padding: 80px 115px 80px 125px;
    box-sizing: content-box;
  }

  .main-pdp-image {
    border-radius: 4px;
  }
  .product-image {
    margin: 0 auto;
  }

  .product-hero-image {
    @media (min-width: 768px) {
      padding-left: 4px;
      padding-right: 4px;
    }
  }
`

const TitleAndInfo = styled(Box)`
  .faq-area {
    border-top: 0 solid ${theme.wild.color.master.base.alt.secondary};

    p,
    h2 {
      color: #fff !important;
    }
  }

  padding-left: 16px;
  padding-right: 16px;

  .supplink {
    border-bottom: 1px solid #fff;
    margin: 0;
    @media (min-width: 768px) {
      margin: 24px 0 0 0;
    }
  }

  .container-dosage {
    span {
      display: inline-block !important;
    }
  }

  @media (min-width: 768px) {
    padding-right: 0;
    padding-left: 24px;
    .sticky {
      max-width: 490px;
      width: 100%;
      margin: 0 auto;
      top: 120px;
      z-index: 0;
    }
  }
  @media (min-width: 1170px) {
    padding-left: 0;
  }

  .title {
    @media (min-width: 768px) {
      text-align: left;

      @media (max-width: 1023px) {
        font-size: 32px !important;
        line-height: 28.8px !important;
      }
    }
  }

  .link-with-arrow {
    text-transform: none;
  }
`
const ImageWrap = styled(Box)`
  margin: 0 0 35px;
  position: relative;

  @media (min-width: 768px) {
    margin: 0 auto;
    .sticky {
      top: 250px;
      z-index: 0;
    }
  }
`
const ModalContentImage = styled.div`
  padding: 24px 0;
`

const IconsWrap = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-content: space-between;
  padding: 16px 0 40px;
  gap: 16px;
  border-top: 1px solid #c8d2d1;
  @media (min-width: 768px) {
    flex-direction: row;
    padding: 48px 0;
  }
  @media (min-width: 1024px) {
    gap: 0;
    padding: 64px 0;
  }
`

const Icon = styled(Flex)`
  flex-direction: row;
  align-items: center;
  gap: 8px;
  @media (min-width: 768px) {
    flex-direction: column;
    text-align: center;
    .el-text {
      font-size: 12px !important;
      line-height: 16.8px !important;
    }
  }

  svg {
    width: 100%;
  }
`

const FlexMobile = styled(Flex)`
  flex-direction: column;
  gap: 24px;
  @media (min-width: 768px) {
    display: none;
  }
`

const ModalContent = ({ image }) => {
  return (
    <ModalContentImage className={`ModalContentImage`}>
      <Image filename={image} classes="supplement-label" />
    </ModalContentImage>
  )
}

const MenATCActiveCleanse = ({
  data,
  purchase_source,
  viewedEvent = true,
  isPromo,
}) => {
  const {
    title,
    subtitle,
    mainimg,
    mainalt,
    supplement_label,
    supplement_label2 = false,
    questions,
    imageArea,
    options,
    icons,
    coreUpsell,
  } = data

  const copy3 = `View Ingredients List`
  const copy4 =
    questions && questions[questions.length - 1]?.answer[1]?.label
      ? questions[questions.length - 1].answer[1]?.label
      : copy3
  const [modalVisible, toggleModalVisible] = useState(false)
  const [modalVisible2, toggleModalVisible2] = useState(false)

  ////////////////// HANDLE ATC DATA START
  const userState = useContext(UserContext)
  useEffect(() => {
    userState.setAtcData(data)
    userState.setActiveOption(0)
    if (viewedEvent) {
      segmentEvent("Product Viewed", {
        image_url: mainimg,
        name: options[0].name_magento || title,
      })
    }
    return () => {
      userState.setAtcData(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  ////////////////// HANDLE ATC DATA END

  const showModal = () => {
    toggleModalVisible(true)
    segmentEvent("Modal Viewed", {
      name: copy3,
    })
  }

  const showModal2 = () => {
    toggleModalVisible2(true)
    segmentEvent("Modal Viewed", {
      name: copy4,
    })
  }

  const renderIcons =
    icons && icons.map
      ? icons.map((el, idx) => {
          return (
            <Icon key={`i${idx}`} className={`i${idx}`} width={[1, 1, 1 / 3]}>
              <Box width={[24, 24, 1]}>
                <CheckedIcon />
              </Box>
              <Box width={[1]} flex={1}>
                <TextElementMen
                  element="p"
                  text={el.text}
                  className="body--regular el-text text-men-base-default"
                />
              </Box>
            </Icon>
          )
        })
      : null

  return (
    <ATCFullWrap>
      <ATCWrap className="row cf">
        <ImageWrap width={[1, null, 0.505]} className={``} order={[1, 1, 0]}>
          <Box mb={[0]} className={`show-md-up product-hero-image`}>
            <Image
              filename={mainimg}
              classes="product-image main-pdp-image"
              alt={mainalt}
            />
          </Box>
          <ImageArea data={imageArea} />
        </ImageWrap>
        <TitleAndInfo
          width={[1, null, 0.495]}
          order={[0, 0, 1]}
          pt={[0, 0, 0, 0]}
        >
          <div className="sticky">
            <Box
              width={[1]}
              mx={"auto"}
              className={`show-md-up`}
              pb={[16, 16, 24]}
            >
              <TextElementMen
                element="h2"
                text={title}
                className="title--large title text-men-base-default gotham"
              />
            </Box>
            <FlexMobile>
              <Box width={[1]} mx={"auto"}>
                <TextElementMen
                  element="h2"
                  text={title}
                  className="title--medium title text-men-base-default gotham text-center"
                />
              </Box>
              <Image
                filename={mainimg}
                classes="product-image main-pdp-image"
                alt={mainalt}
              />
              <TextElementMen
                element="p"
                text={subtitle}
                className="body--regular text-center text-men-base-default"
              />
            </FlexMobile>
            <div className={`show-md-up`}>
              <TextElementMen
                element="p"
                text={subtitle}
                className="body--regular text-men-base-default "
              />
              {supplement_label2 === false && (
                <TextElementMen
                  element="button"
                  onClick={showModal}
                  onKeyPress={showModal}
                  text={copy3}
                  className="mono--small text-men-base-default uppercase supplink"
                />
              )}
            </div>
            {isPromo ? (
              <MenSingleOptionPromo2in1
                data={options}
                purchase_source={purchase_source}
              />
            ) : (
              <MenSingleOption
                data={options}
                purchase_source={purchase_source}
              />
            )}

            <div className={`hide-md-up supplinkmob`}>
              {supplement_label2 === false && (
                <TextElementMen
                  element="button"
                  onClick={showModal}
                  onKeyPress={showModal}
                  text={copy3}
                  className="mono--small uppercase supplink text-men-base-default"
                />
              )}
            </div>
            <Box pt={[16, 16, 24]} pb={[40, 40, 48, 64]}>
              <HairSerumCoreUpsell data={coreUpsell} />
            </Box>
            <IconsWrap>{renderIcons}</IconsWrap>
            <FaqArea
              className="faq-area"
              questions={questions}
              showModal={showModal}
              showModal2={showModal2}
            />
          </div>
        </TitleAndInfo>
      </ATCWrap>
      <div className={`supplinkwrap`}>
        {modalVisible && (
          <ModalWildImage
            component={ModalContent}
            propsObject={{
              image: supplement_label,
            }}
            hideModal={() => toggleModalVisible(false)}
            modalSize="small"
          />
        )}
        {modalVisible2 && (
          <ModalWildImage
            component={ModalContent}
            propsObject={{
              image: supplement_label2,
            }}
            hideModal={() => toggleModalVisible2(false)}
            modalSize={`small ${copy4.toLowerCase()}`}
          />
        )}
      </div>
    </ATCFullWrap>
  )
}

export default MenATCActiveCleanse
